module.exports = __webpack_public_path__ + "static/whitepaper@2x-b64613c1dff6d4fea6aee8abd74507f0.png";